
export const VODAFONE_GLOBAL_ID = '10143060198421'

export const isVodafoneGlobalUser = (defaultPlatformUnitId: string | null): boolean => (
  defaultPlatformUnitId === VODAFONE_GLOBAL_ID
)

export type VodafoneMarket = {
  name: string
  id: string
  slug: string
  iso_code: string
  ordinal_no: number
  creativeXMarket: string
  shareOfSpendTarget: number | null
}

export const vodafoneMarkets: VodafoneMarket[] = [
  {
    name: 'Germany',
    id: '12830040392735',
    iso_code: 'DE',
    slug: 'vodafone-de',
    ordinal_no: 1,
    creativeXMarket: 'Germany',
    shareOfSpendTarget: 29,
  },
  {
    name: 'United Kingdom',
    id: '31774511989840',
    iso_code: 'UK',
    slug: 'vodafone-uk',
    ordinal_no: 2,
    creativeXMarket: 'United Kingdom',
    shareOfSpendTarget: 15,
  },
  {
    name: 'South Africa',
    id: '32230978094163',
    iso_code: 'ZA',
    slug: 'vodacom-za',
    ordinal_no: 5,
    creativeXMarket: 'South Africa',
    shareOfSpendTarget: 37,
  },
  {
    name: 'Turkey',
    id: '31268880254029',
    iso_code: 'TR',
    slug: 'vodafone-tr',
    ordinal_no: 6,
    creativeXMarket: 'Turkey',
    shareOfSpendTarget: 30,
  },
  {
    name: 'Egypt',
    id: '13480333673507',
    iso_code: 'EG',
    slug: 'vodafone-eg',
    ordinal_no: 7,
    creativeXMarket: 'Egypt',
    shareOfSpendTarget: 35,
  },
  {
    name: 'Ireland',
    id: '23753861891122',
    iso_code: 'IE',
    slug: 'vodafone-ie',
    ordinal_no: 8,
    creativeXMarket: 'Ireland',
    shareOfSpendTarget: 26,
  },
  {
    name: 'Portugal',
    id: '27303811744836',
    iso_code: 'PT',
    slug: 'vodafone-pt',
    ordinal_no: 9,
    creativeXMarket: 'Portugal',
    shareOfSpendTarget: 30,
  },
  {
    name: 'Greece',
    id: '21641224520748',
    iso_code: 'GR',
    slug: 'vodafone-gr',
    ordinal_no: 10,
    creativeXMarket: 'Greece',
    shareOfSpendTarget: null,
  },
  {
    name: 'Romania',
    id: '30509216302154',
    iso_code: 'RO',
    slug: 'vodafone-ro',
    ordinal_no: 11,
    creativeXMarket: 'Romania',
    shareOfSpendTarget: 35,
  },
  {
    name: 'Czech Republic',
    id: '10734373176347',
    iso_code: 'CZ',
    slug: 'vodafone-cz',
    ordinal_no: 12,
    creativeXMarket: 'Czechia',
    shareOfSpendTarget: 35,
  },
  {
    name: 'Albania',
    id: '10336979649558',
    iso_code: 'AL',
    slug: 'vodafone-al',
    ordinal_no: 13,
    creativeXMarket: 'Albania',
    shareOfSpendTarget: 50,
  }
]


export const legacyMarkets: VodafoneMarket[] = [
  {
    name: 'Hungary',
    id: '22432882623535',
    iso_code: 'HU',
    slug: 'vodafone-hu',
    ordinal_no: 14,
    creativeXMarket: '',
    shareOfSpendTarget: null,
  },
  {
    name: 'Netherlands',
    id: '6431964473713034534',
    iso_code: 'NL',
    slug: 'vodafone-nl',
    ordinal_no: 15,
    creativeXMarket: '',
    shareOfSpendTarget: null,
  },
]

export const partnerMarkets: VodafoneMarket[] = [
  {
    name: 'Italy',
    id: '24907052221496',
    iso_code: 'IT',
    slug: 'vodafone-it',
    ordinal_no: 3,
    creativeXMarket: 'Italy',
    shareOfSpendTarget: 22,
  },
  {
    name: 'Spain',
    id: '14851904635942',
    iso_code: 'ES',
    slug: 'vodafone-es',
    ordinal_no: 4,
    creativeXMarket: 'Spain',
    shareOfSpendTarget: 22,
  },
  {
    name: 'Australia',
    id: '6431964309285576585',
    iso_code: 'AU',
    slug: 'vodafone-au',
    ordinal_no: 16,
    creativeXMarket: '',
    shareOfSpendTarget: null,
  },
  {
    name: 'Qatar',
    id: '6431964397345773869',
    iso_code: 'QA',
    slug: 'vodafone-qa',
    ordinal_no: 17,
    creativeXMarket: '',
    shareOfSpendTarget: null,
  },
]


// NOTE - some views in this application are necessarily written
// with hardcoded data and don't have privileges modelled in the system.
// For now, we're forced to represent slowly-changing view restrictions on
// some markets through this kind of cruft.
export const groupOnlyMarketIsoCodes: string[] = [
  'UK',
]
